// extracted by mini-css-extract-plugin
export default {"container":"AppLayout_container__F1fjg","bold":"AppLayout_bold__wbR2l","kiaiLogo":"AppLayout_kiaiLogo__io-OJ","divider":"AppLayout_divider__syAES"};